import React, { useState, useEffect } from 'react';
import '../styles/AgriculturalCategory.css';
import pic1 from "../assets/agri science (1).png";
import pic2 from "../assets/agri chem (1).png";
import pic3 from "../assets/agri biology (1).png";
import pic4 from "../sciencelabs/agriculture (3).webp";

const AgriculturalCategory = () => {
  const [currentImageSlide, setCurrentImageSlide] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  // Slider Images Only
  
  const sliderImages = [
    pic4,
  ];

  // All Subjects
  const subjects = [
    {
      id: 1,
      name: 'Agricultural Science',
      description: 'Master the principles of modern farming and crop production. Learn about soil management, crop rotation, pest control, and sustainable agricultural practices.',
      icon: pic1,
    },
    {
      id: 2,
      name: 'Agricultural Chemistry',
      description: 'Understand the chemical aspects of agriculture. Study soil chemistry, nutrient management, fertilizers, and their effects on plant growth and productivity.',
      icon: pic2,
    },
    {
      id: 3,
      name: 'Agricultural Biology',
      description: 'Explore the biological principles in agriculture. Study plant biology, animal husbandry, genetics, and ecological relationships in farming systems.',
      icon: pic3,
    }
  ];

  // Auto-play slider
  useEffect(() => {
    if (!autoPlay) return;
    
    const interval = setInterval(() => {
      setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [autoPlay, sliderImages.length]);

  const nextSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const prevSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const goToImageSlide = (index) => {
    setAutoPlay(false);
    setCurrentImageSlide(index);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  return (
    <>
      {/* Agricultural Banner */}
      <div className="ag-banner-section">
        <div className="ag-banner-overlay"></div>
        <div className="ag-banner-content">
          <h1 className="ag-banner-title">AGRICULTURAL SCIENCE</h1>
        </div>
      </div>

      {/* Main Agricultural Section */}
      <section className="ag-main-section" id="ag-agri-main">
        {/* About & Slider Container - Side by Side */}
        <div className="ag-about-slider-container">
          {/* Left - About Section */}
          <div className="ag-about-wrapper">
            <div className="ag-description-block">
              <h2 className="ag-section-title">About <span className="ag-title-highlight">Agricultural Science</span></h2>
              <p className="ag-description-text">
                The Agricultural Science stream combines scientific knowledge with practical farming expertise. Our comprehensive 
                curriculum focuses on sustainable agriculture, crop production, soil science, and agribusiness. Students learn 
                modern farming techniques, environmental conservation, and develop skills to contribute to agricultural 
                development and food security.
              </p>
            </div>
          </div>

          {/* Right - Image Slider */}
          <div className="ag-slider-wrapper">
            <div className="ag-image-carousel">
              {/* Image Display */}
              <div className="ag-image-display">
                {sliderImages.map((image, index) => (
                  <div 
                    key={index}
                    className={`ag-image-item ${index === currentImageSlide ? 'ag-image-active' : ''}`}
                  >
                    <img src={image} alt={`Agricultural ${index + 1}`} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Agricultural Subjects Section */}
        <div className="ag-content-section">
          <div className="ag-subjects-container">
            <h3 className="ag-subjects-heading">Our <span className="ag-heading-accent">Subjects</span></h3>
            
            <div className="ag-subjects-grid">
              {subjects.map((subject) => (
                <div 
                  key={subject.id} 
                  className="ag-subject-card"
                >
                   <div className="cc-card-icon">
                    <img src={subject.icon} alt={subject.name}  className="lab-item-iconcc"/>
                  </div>
                  <h4 className="ag-card-title">{subject.name}</h4>
                  <p className="ag-card-desc">{subject.description.substring(0, 80)}...</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AgriculturalCategory;